<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="75%">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          {{ titleModal }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="edit = !edit" slot="activator">
              <v-icon>edit</v-icon>
            </v-btn>
            <span>Alterar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <p v-if="!edit && editSql" class="title">{{ sql.Descricao }}</p>
          <v-divider v-if="!edit && editSql" class="mb-3"></v-divider>
          <v-text-field 
            v-if="edit || !editSql"
            v-model="sql.Descricao" 
            label="Descrição do sql"
            @keyup.enter="adiciona"
            autofocus
            outline
            spellcheck="false"
          ></v-text-field>
          <pre v-if="!edit && editSql">{{ sql.InstrucaoSql }}</pre>
          <SharedTextarea
            v-if="edit || !editSql"
            :value="sql.InstrucaoSql"
            @change="v => sql.InstrucaoSql = v"
            label="Instrução Sql" 
            hide-details
            outline
            spellcheck="false"
            class="font-code"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Sql from '@/domain/sql/Sql';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'ModalEditCadastroSql',
  props: ['editSql', 'value'],
  components: {
    SharedTextarea
  },
  data() {
    return {
      loading: false,
      edit: false
    }
  },
  computed: {
    sql() {
      return this.editSql ? this.editSql : new Sql()
    },
    titleModal() {
      return this.editSql ? 'Editar Sql' : 'Novo Sql'
    }
  },
  methods: {
    ...mapActions(['addSql', 'updateSql']),
    ...mapMutations(['showNotification', 'closeNotification']),
    async adiciona() {
      if (this.sql.Descricao) {
        this.loading = true;
        try {
          if (!this.sql.IdSql) {
            await this.addSql(this.sql);
          } else {
            await this.updateSql(this.sql);
          }
          this.loading = false;
          this.edit = false;
          this.$emit('input');
          this.showNotification({ text: `Sql: ${this.sql.Descricao} ${this.sql.IdSql ? 'atualizado' : 'adicionado'} com sucesso.`, status: 'success' });
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o sql: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do sql.`, status: 'error' });
      }
    }
  }
}
</script>

<style>
.font-code {
  font-family: 'Courier New', Courier, monospace;
}
</style>
